module.exports = __webpack_public_path__ + "static/media/drinksbucket-logo.c2222cd3.png";